<div class="section" id="experience">
    <div class="container py-2 cc-experience">
        <div class="h4 text-center mb-4 title">Work Experience</div>
                <div class="row">
                    <ul class="timeline">
                        <li>
                            <div class="timeline-badge up bg-green">
                                <i class="fa fa-thumbs-up"></i>
                            </div>
                            <div class="timeline-panel">

                                <div class="row">
                                    <div class="col-lg-6 ">
                                        <div class="h5 mt-0 title">US Bank</div>
                                        <div class="h6 mt-0 title"> Senior Software Engineer (2026 - Present)</div>
                                        <p align="justify"><b>US Bank</b> is an American multinational banking institution headquartered in Minneapolis, Minnesota and incorporated in Delaware. It is the 5th-largest bank in the United States as of 2025. As the largest bank in the Midwestern United States, it is considered systemically important by the Financial Stability Board., 
                                          The organization operates at enterprise scale, supporting modern banking technologies, cloud platforms, data-driven systems, and highly secure digital experiences across multiple business domains.
                                            </p>
                                        <p align="justify">As a <b>Senior Software Engineer at U.S. Bank </b>, I lead the onshore engineering team in designing and delivering scalable enterprise applications used across critical banking platforms. My role focuses on driving technical execution, collaborating with cross-functional stakeholders,
                                          and building high-performance solutions that improve both customer and operational experiences.</p>

<p align="justify"> I work across the full software development lifecycle — from architecture discussions and system design to implementation, deployment, and production support. I actively contribute to frontend and backend engineering using modern technologies including React, Node.js, TypeScript, microservices, cloud platforms, and CI/CD pipelines.</p>
                                    </div>    
                                    <div class="col-lg-6">       
                                        <ul>
                                            <li class="list">Core Functionality</li>
                                            <ul>
                                                <li class="non_list">Lead Software Development</li>
                                                <li class="non_list">Full Stack Developer</li>
                                            </ul>
                                            <li class="list">Technologies and Language</li>
                                            <ul>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <li class="non_list">React</li>
                                                        <li class="non_list">NextJs</li>
                                                        <li class="non_list">JavaScript</li>
                                                        <li class="non_list">NodeJs</li>
                                                        <li class="non_list">PostgreSQL</li>
                                                        <li class="non_list">Ajax, Axios</li>
                                                        <li class="non_list">Microservices</li>
                                                        <li class="non_list">GraphQL</li>
                                                        <li class="non_list">Git, Gitlab</li>
                                                        <li class="non_list">AI, LLMs</li>
                                                      <li class="non_list">Jest, Unit Tests</li>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <li class="non_list">CI/CD</li>
                                                        <li class="non_list">Kubernetes</li>
                                                        <li class="non_list">Fortify</li>
                                                        <li class="non_list">DataDog</li>
                                                        <li class="non_list">Black Duck</li>
                                                        <li class="non_list">DevOps Practices</li>
                                                        <li class="non_list">Service Now</li>
                                                        <li class="non_list">Azure</li>
                                                    </div>
                                                </div>   
                                            </ul>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </li> 
                        <li>
                            <div class="timeline-badge up bg-green">
                                <i class="fa fa-thumbs-up"></i>
                            </div>
                            <div class="timeline-panel">

                                <div class="row">
                                    <div class="col-lg-6 ">
                                        <div class="h5 mt-0 title">Paycom</div>
                                        <div class="h6 mt-0 title"> Senior Software Engineer (2023 - 2026)</div>
                                        <p align="justify"><b>Paycom</b> is a leading provider of cloud-based human capital management (HCM) software 
                                            that helps businesses manage the complete employee lifecycle. With a focus on automating payroll, HR tasks, talent management, and compliance, Paycom delivers solutions that enhance workforce efficiency and simplify complex HR processes. 
                                            By integrating all functions into a single, easy-to-use application, 
                                            Paycom empowers organizations to streamline their operations and improve employee engagement, making it a key player in the HR tech industry.</p>
                                        <p align="justify">WWorking as a Software Engineer, I design, develop, and maintain web applications and software solutions, focusing on delivering high-quality, scalable systems. My responsibilities include writing clean, efficient code, collaborating with cross-functional teams, and 
                                            continuously improving performance and functionality to meet user and business needs.</p>
                                    </div>    
                                    <div class="col-lg-6">       
                                        <ul>
                                            <li class="list">Core Functionality</li>
                                            <ul>
                                                <li class="non_list">Software Development</li>
                                                <li class="non_list">Full Stack Dev</li>
                                            </ul>
                                            <li class="list">Technologies and Language</li>
                                            <ul>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <li class="non_list">React</li>
                                                        <li class="non_list">JavaScript</li>
                                                        <li class="non_list">PHP</li>
                                                        <li class="non_list">SQL</li>
                                                        <li class="non_list">Ajax</li>
                                                        <li class="non_list">C#</li>
                                                        <li class="non_list">Rest API</li>
                                                        <li class="non_list">Git</li>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <li class="non_list">Redux</li>
                                                        <li class="non_list">Python</li>
                                                        <li class="non_list">ES6</li>
                                                        <li class="non_list">CSS3</li>
                                                    </div>
                                                </div>   
                                            </ul>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </li>   
                        <li>
                            <div class="timeline-badge up bg-green">
                                <i class="fa fa-thumbs-up"></i>
                            </div>
                            <div class="timeline-panel">

                                <div class="row">
                                    <div class="col-lg-6 ">
                                        <div class="h5 mt-0 title">Cognizant Technology Solutions</div>
                                        <div class="h6 mt-0 title">Associate Software Engineer (2018-06 - 2021-08)</div>
                                        <p align="justify"><b>Cognizant</b> is a global leader in professional services, providing IT consulting, technology, and digital transformation solutions to help businesses innovate and grow. Specializing in areas such as software development, cloud solutions, data analytics, and artificial intelligence, Cognizant partners with clients across industries to modernize their technology and enhance business agility. Known for its focus on customer-centric solutions, 
                                            Cognizant is dedicated to driving digital transformation and operational efficiency for organizations worldwide.</p>
                                    </div>    
                                    <div class="col-lg-6">       
                                        <ul>
                                            <li class="list">Core Functionality</li>
                                            <ul>
                                                <li class="non_list">Software Development</li>
                                                <li class="non_list">Web Application Development</li>
                                            </ul>
                                            <li class="list">Technologies and Language</li>
                                            <ul>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <li class="non_list">React</li>
                                                        <li class="non_list">Angular</li>
                                                        <li class="non_list">JavaScript</li>
                                                        <li class="non_list">Rest API</li>
                                                        <li class="non_list">Git</li>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <li class="non_list">Redux</li>
                                                        <li class="non_list">Python</li>
                                                        <li class="non_list">ES6</li>
                                                        <li class="non_list">CSS3</li>
                                                    </div>
                                                </div>   
                                            </ul>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            

                        </li>  


                      
                        <!-- <li>
                            <div class="timeline-badge down">
                                <i class="fa fa-users"></i>
                            </div>
                            <div class="timeline-panel">
                                <div class="row">
                                    <div class="col-lg-6 ">
                                        <div class="h5 mt-0 title">Novelsynth Soft Solution Pvt Ltd</div>
                                        <div class="h6 mt-0 title">Associate Software Engineer (2018-07 - 2019-08)</div>
                                        <p align="justify">Worked as a Software developer to develop analytical and visualization solution for oil and gas industries.</p>
                                    </div>    
                                    <div class="col-lg-6">       
                                        <ul>
                                            <li class="list">Core Functionality</li>
                                            <ul>
                                                <li class="non_list">Software Development</li>
                                                <li class="non_list">Application Development</li>
                                                <li class="non_list">Web Development</li>
                                            </ul>
                                            <li class="list">Technologies and Language</li>
                                            <ul>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <li class="non_list">Java</li>
                                                        <li class="non_list">Hibernate</li>
                                                        <li class="non_list">Maven</li>
                                                        <li class="non_list">Mysql</li>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <li class="non_list">Python</li>
                                                        <li class="non_list">Microsoft Azure</li>
                                                        <li class="non_list">Vaadin Web Framework</li>
                                                        <li class="non_list">Git</li>
                                                    </div>
                                                </div>   
                                            </ul>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li> -->
                    </ul>
                </div>
    </div>
</div>
        
